/**
 * @module geo/components
 *
 */

import { ExtensionType } from "../types/extensions";

import { Component } from "./component";

/**
 * All toolbar on map
 * If hidden all tool in toolbar are unavailable.
 * To hide specific tool hide the specific sub component : 
 *  - [[MapBasicControls]],
 *  - [[MapGeolocation]],
 *  - [[MapSelectionTools]],
 *  - [[MapIdentifierTool]]
 *  - [[MapScalePicker]] 
 *  - [[MapScaleLine]] 
 *  - [[MapToolsControl]] 
 *  - [[MeasureTool]] 
 * 
 * @since 2.1.0
 */
export class MapTools extends Component {
  public defaultExtensionType = ExtensionType.MAP_TOOL;
}

/**
 * Scale line for the main map.
 * @since v2.0.1
 */
export class MapScaleLine extends Component {}

/**
 * Show a component to choose a scale.
 * @since v2.0.1
 */
export class MapScalePicker extends Component {}

/**
 * Basic controls for map, like navigation.
 * @since v2.0.1
 *
 */
export class MapBasicControls extends Component {}

/**
 * A button helping user to locate on his position.
 * @since v2.0.1
 */
export class MapGeolocation extends Component {}

/**
 * A button to activate the Map Identifier tool.
 * @since v2.0.1
 */
export class MapIdentifierTool extends Component {}

/**
 * Selection tool button
 */
export class MapSelectionTools extends Component {}

/**
 * @private
 * @since 2.1.0
 */
export class MapToolsControl extends Component {}

/**
 * A button to show measure tool.
 * @since v2.0.1
 */
export class MeasureTool extends Component {}
